export default __webpack_public_path__ + "static/hero-99e85bf4f1b573993908a29f54b905f5.jpg";